import { useHistory } from 'react-router-dom';
import Button from '../Button';

import {
  Container,
  Headline,
  LeftContainer,
  CenterContainer,
  RightContainer,
  PersonImage,
} from './styles';
import personImage1 from '../../assets/image/person-1.jpg';
import personImage2 from '../../assets/image/person-2.jpg';
import personImage3 from '../../assets/image/person-3.jpg';
import personImage4 from '../../assets/image/person-4.jpg';
import personImage5 from '../../assets/image/person-5.jpg';
import personImage6 from '../../assets/image/person-6.jpg';
import personImage7 from '../../assets/image/person-7.jpg';
import personImage8 from '../../assets/image/person-8.jpg';
import personImage9 from '../../assets/image/person-9.jpg';
import personImage10 from '../../assets/image/person-10.jpg';
import personImage11 from '../../assets/image/person-11.jpg';
import personImage12 from '../../assets/image/person-12.jpg';
import personImage13 from '../../assets/image/person-13.jpg';
import personImage14 from '../../assets/image/person-14.jpg';
import personImage15 from '../../assets/image/person-15.jpg';

const BecomeDesignerSection = () => {
  const history = useHistory();

  function handleButtonClick() {
    history.push('/become-designer');
  }

  return (
    <Container>
      <LeftContainer
        backgroundUrl={`${process.env.PUBLIC_URL}/images/designer-section-background-left.png`}
      >
        <div />
        <PersonImage
          src={personImage1}
          alt="Pessoa"
          height={130}
          style={{ alignSelf: 'center' }}
        />
        <PersonImage
          src={personImage2}
          alt="Pessoa"
          height={43}
          style={{ alignSelf: 'center', marginLeft: '50px' }}
        />
        <PersonImage src={personImage3} alt="Pessoa" height={90} />
        <PersonImage
          src={personImage4}
          alt="Pessoa"
          height={43}
          style={{ alignSelf: 'center', marginLeft: '30px' }}
        />
        <PersonImage
          src={personImage5}
          alt="Pessoa"
          height={67}
          style={{ alignSelf: 'flex-end', marginLeft: '20px' }}
        />
        <PersonImage src={personImage6} alt="Pessoa" height={90} />
        <PersonImage
          src={personImage7}
          alt="Pessoa"
          height={63}
          style={{ marginLeft: '50px', alignSelf: 'center' }}
        />
      </LeftContainer>
      <CenterContainer>
        <Headline>
          Você é <br />
          <strong>Designer?</strong>
        </Headline>
        <Button
          text="Quero vender meus projetos"
          primary
          onClick={handleButtonClick}
        />
      </CenterContainer>
      <RightContainer
        backgroundUrl={`${process.env.PUBLIC_URL}/images/designer-section-background-right.png`}
      >
        <div>
          <PersonImage
            src={personImage8}
            alt="Pessoa"
            height={42}
            style={{ alignSelf: 'center', marginLeft: '30px' }}
          />
          <PersonImage
            src={personImage9}
            alt="Pessoa"
            height={136}
            style={{ alignSelf: 'center', marginLeft: '50px' }}
          />
          <div />

          <PersonImage
            src={personImage10}
            alt="Pessoa"
            height={91}
            style={{ alignSelf: 'center', marginLeft: '30px' }}
          />
          <PersonImage
            src={personImage11}
            alt="Pessoa"
            height={41}
            style={{ alignSelf: 'center', marginLeft: '100px' }}
          />
          <PersonImage
            src={personImage12}
            alt="Pessoa"
            height={124}
            style={{ alignSelf: 'flex-end', marginLeft: '20px' }}
          />
          <PersonImage
            src={personImage13}
            alt="Pessoa"
            height={67}
            style={{ alignSelf: 'flex-end' }}
          />
          <PersonImage
            src={personImage14}
            alt="Pessoa"
            height={91}
            style={{ marginLeft: '50px', alignSelf: 'center' }}
          />
          <PersonImage
            src={personImage15}
            alt="Pessoa"
            height={66}
            style={{ alignSelf: 'flex-end' }}
          />
        </div>
      </RightContainer>
    </Container>
  );
};

export default BecomeDesignerSection;
